<script>
  import { createEventDispatcher } from 'svelte';
  import Toggle from '@components/Toggle.svelte';

  const dispatch = createEventDispatcher();

  export let togglerEnabled = false;
  export let title;
  export let description;

  // If simple, there is only a title, and no slots, and slightly different styling
  export let simple = true;
  export let endOfSection = false;
  export let progress = false;

  const dispatchToggled = () => {
    dispatch('toggle', { newValue: !togglerEnabled });
  };

  const dispatchIfClickable = function () {
    if (progress) {
      dispatch('clicked');
    }
  };
</script>

<style style="text/scss" lang="scss">
  .progress-further {
    cursor: pointer;
    path {
      fill: #a893f9;
    }
    &:hover {
      path {
        fill: #d5cfea;
      }
    }
  }
  .advanced-settings-toggle {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.end-of-section {
      border-bottom: 1px solid rgb(238, 238, 238);
      padding-bottom: 30px;
      margin-bottom: 20px;
    }
  }

  .title-and-desc-container {
    margin-right: 25px;
    flex: 1;

    .title-container {
      display: flex;

      .title {
        font-weight: 500;
      }
    }

    .desc-container {
      margin-top: 10px;
      line-height: 24px;

      .desc {
        opacity: 0.5;
      }
    }
  }

  .simple-title {
    opacity: 0.5;
    font-size: 14px;
    font-weight: 500;
    margin-right: 25px;
  }
</style>

<div
  class="advanced-settings-toggle"
  class:end-of-section={endOfSection}
  class:progress-further={progress}
  on:click|preventDefault|stopPropagation={dispatchIfClickable}>
  <!-- <div class="checkbox-container">
    <span
      on:click={dispatchToggled}
      class="ui-toggler"
      class:togger-enabled={togglerEnabled} />
  </div> -->

  {#if simple}
    <span class="simple-title">{title}</span>
  {:else}
    <div class="title-and-desc-container">
      <div class="title-container">
        <div class="title">{title}</div>
        <slot name="title-action" />
      </div>

      {#if description}
        <div class="desc-container">
          <span class="desc">
            {description}
          </span>
          <slot name="description-action" />
        </div>
      {/if}
    </div>
  {/if}
  {#if progress}
    <div class="procedd-button">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.34767 2.87789C5.81732 3.62037 5.90331 4.72385 6.53972 5.34259L14.1569 12.7482L6.53972 20.1537C5.90331 20.7725 5.81732 21.876 6.34767 22.6185C6.87801 23.3609 7.82386 23.4612 8.46028 22.8425L17.4603 14.0926C17.8023 13.7601 18 13.2675 18 12.7482C18 12.2288 17.8023 11.7363 17.4603 11.4038L8.46028 2.65382C7.82386 2.03509 6.87801 2.13541 6.34767 2.87789Z"
          fill="#AE94F9" />
      </svg>
    </div>
  {:else}
    <Toggle enabled={togglerEnabled} on:toggled={dispatchToggled} />
  {/if}
</div>
